import type { CombinedLayoutConfig, SimpleLayoutCfg } from './base-product-tile-types.js'

export type CardVariant = 'default' | 'wide' | 'inline'

const COMBINED_LAYOUT_KEYS = ['grid', 'list', 'gridMobile', 'listMobile'] as const

export const isListCardVariant = (cardVariant: CardVariant): boolean => cardVariant === 'wide' || cardVariant === 'inline'

export const isCombinedLayoutConfig = (value: unknown): value is CombinedLayoutConfig =>
  !!value && typeof value === 'object' && COMBINED_LAYOUT_KEYS.some(key => key in value)

export const isSimpleLayoutConfig = (value: unknown): value is SimpleLayoutCfg =>
  !!value && typeof value === 'object' && ('image' in value || 'productInfo' in value || 'orderActions' in value)

const selectCombinedBranch = (config: CombinedLayoutConfig, cardVariant: CardVariant, mobile: boolean): SimpleLayoutCfg | undefined => {
  if (isListCardVariant(cardVariant)) {
    return (mobile ? config.listMobile : undefined) ?? config.list ?? config.grid
  }
  return (mobile ? config.gridMobile : undefined) ?? config.grid
}

export const resolveLayoutConfig = (config: CombinedLayoutConfig | SimpleLayoutCfg | null | undefined, cardVariant: CardVariant, mobile = false): SimpleLayoutCfg => {
  const selected = isCombinedLayoutConfig(config)
    ? selectCombinedBranch(config, cardVariant, mobile)
    : isSimpleLayoutConfig(config) ? config : undefined
  return {
    ...selected,
    image: selected?.image ?? {},
    productInfo: selected?.productInfo ?? {},
    orderActions: selected?.orderActions ?? {},
  }
}
